import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import useInternetStatus from 'hooks/use-internet-status';
import OfflineNotification from 'components/internet-notifications/offline-notification/offline-notification';
import ConnectionRestoredNotification from 'components/internet-notifications/restored-notification/restored-notification';
const InternetStatus = () => {
    const [connectionRestoredVisible, setConnectionRestoredVisible] = useState(false);
    const isOnline = useInternetStatus();
    const handleConnectionRestoredDismiss = () => {
        setConnectionRestoredVisible(false);
    };
    const handleConnectionRestoredDisplay = () => {
        setConnectionRestoredVisible(true);
    };
    return (_jsx("div", { children: !isOnline ? (_jsx(OfflineNotification, { onDisplay: handleConnectionRestoredDisplay }, void 0)) : (_jsx(ConnectionRestoredNotification, { isVisible: connectionRestoredVisible, onDismiss: handleConnectionRestoredDismiss }, void 0)) }, void 0));
};
export default InternetStatus;
